import { observer } from "mobx-react";
import { Checkbox, Select, Alert, Form } from "antd";

interface RouteViewConfigStepProps {
  data: {
    routeViewImpactAssessmentEnabled: boolean;
    defaultLoadDay: string;
  };
  modules: {
    routeView: boolean;
  };
  onChange: (data: any) => void;
}

const RouteViewConfigStep = observer(({ data, modules, onChange }: RouteViewConfigStepProps) => {
  if (!modules.routeView) {
    return (
      <div className="p-4">
        <Alert message="Route View Not Selected" description="Route View configuration is only applicable when Route View module is selected." type="info" showIcon />
      </div>
    );
  }

  const handleChange = (field: string, value: any) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <div className="p-4">
      <Alert message="Route View Configuration" description="Configure settings specific to the Route View module." type="info" showIcon className="mb-6" />

      <Form layout="vertical">
        <Form.Item label={<div className="font-bold">Impact Assessment</div>} className="mb-8">
          <Checkbox checked={data.routeViewImpactAssessmentEnabled} onChange={(e) => handleChange("routeViewImpactAssessmentEnabled", e.target.checked)}>
            Enable Impact Assessment
          </Checkbox>
          <div className="text-sm text-gray-500 mt-1">Allows users to see the impact of changes before applying them</div>
        </Form.Item>

        <Form.Item label={<div className="font-bold">Default Loading Day</div>} required className="mb-4">
          <Select
            style={{ width: "100%" }}
            value={data.defaultLoadDay}
            onChange={(value) => handleChange("defaultLoadDay", value)}
            options={[
              { label: "Today", value: "today" },
              { label: "Tomorrow", value: "tomorrow" },
            ]}
          />
          <div className="text-sm text-gray-500 mt-1">The default day that will be loaded when users open Route View</div>
        </Form.Item>
      </Form>
    </div>
  );
});

export default RouteViewConfigStep;
